import { render } from "./StatusBadge.vue?vue&type=template&id=f53223e4&scoped=true"
import script from "./StatusBadge.vue?vue&type=script&lang=js"
export * from "./StatusBadge.vue?vue&type=script&lang=js"

import "./StatusBadge.vue?vue&type=style&index=0&id=f53223e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f53223e4"]])

export default __exports__